import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { reduxForm } from 'redux-form';

import { compose } from 'redux';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import DropDownSelect from '../DropDownSelect';

import { validatePopup } from './validations';

import {
    AddressPopupContainer,
    ButtonGroup,
    FormGroup as DefaultFormGroup,
    GroupLabel,
    MultipleGroup,
    Title
} from '../../containers/DefaultStyles/FormDetails';

import { LoadingSpinner } from '../../components/LoadingSpinner';

const FormGroup = styled(DefaultFormGroup)`
    margin-bottom: 0;
`;

const Error = styled.span`
    font-family: Averta;
    font-size: 0.5em;
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: 1px;
    text-align: right;
    color: #ff245e;
    text-transform: uppercase;
    float: right;
    margin-top: 8px;
`;

class AddressForm extends React.Component {
    render() {
        return (
            <AddressPopupContainer onSubmit={this.props.handleSubmit} autocomplete="on">
                <Title>
                    Voter Registration
                    {this.props.isErrorOnSubmit && (
                        <Error>An error occured. Please try again</Error>
                    )}
                </Title>
                <FormGroup>
                    <Field
                        name="postalCode"
                        component={InputGroup}
                        type="text"
                        label="Postal Code"
                        placeholder="Postal Code"
                        autocomplete="on"
                        maxLength={5}
                        value={this.props.postalCode}
                        onChange={this.props.onPostalCodeChange}
                    />
                </FormGroup>
                <GroupLabel>Date of Birth</GroupLabel>
                <MultipleGroup>
                    <Field
                        name="month"
                        component={DropDownSelect}
                        options={this.props.month}
                        defaultOption={'Month'}
                        label="Month"
                        type="text"
                    />
                    <Field
                        name="day"
                        component={DropDownSelect}
                        options={this.props.day}
                        defaultOption={'Day'}
                        label="Day"
                        type="text"
                    />
                    <Field
                        name="year"
                        component={DropDownSelect}
                        options={this.props.year}
                        defaultOption={'Year'}
                        label="Year"
                        type="text"
                    />
                </MultipleGroup>
                <ButtonGroup isAddressSubmitting={this.props.isAddressSubmitting}>
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            label={'Submit'}
                            type="submit"
                            className="submitButton"
                            disabled={this.props.invalid}
                        />
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroup>
            </AddressPopupContainer>
        );
    }
}

AddressForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    isAddressSubmitting: PropTypes.bool,
    month: PropTypes.array,
    year: PropTypes.array,
    day: PropTypes.array,
    postalCode: PropTypes.string,
    onPostalCodeChange: PropTypes.func,
    isErrorOnSubmit: PropTypes.bool
};

export default compose(
    connect(state => ({
        initialValues: {
            postalCode:
                state.cachedFormData.postalCode ||
                state.localRep.localRepData.postalCode ||
                (state.widget.endUserLocation || {}).postalCode ||
                '',
            month: state.cachedFormData.month || '',
            day: state.cachedFormData.day || '',
            year: state.cachedFormData.year || ''
        }
    })),
    reduxForm({
        form: 'addressForm',
        destroyOnUnmount: false,
        validate: validatePopup
    })
)(AddressForm);
